import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentforharihareshwar() {



const cardData =
{
  keyword: 'Bus on Rent for Harihareshwar',
  heading: 'Sanavi Travels: Bus on Rent for Harihareshwar',
  headingDescription: 'Sanavi Travels offers professionally managed Bus on Rent for Harihareshwar services, ideal for families, friends, corporate groups, pilgrims, and tourists planning a peaceful coastal journey. Our buses are designed to handle long outstation travel comfortably, ensuring safe, smooth, and well-coordinated transportation from Pune and nearby areas to Harihareshwar with experienced drivers and reliable vehicles.',

  top: 'Top Travel Experiences & Destinations While Visiting Harihareshwar',

  "topPlaces": [
    {
      "title": "Harihareshwar Temple Darshan",
      "description": "Harihareshwar Temple is one of the most revered pilgrimage destinations on the Konkan coast, attracting devotees from Maharashtra and beyond. Traveling by bus allows families and large groups to journey together peacefully, maintaining spiritual focus without travel stress. The scenic coastal roads, combined with organized group travel, make the journey as memorable as the darshan itself. Spacious seating, smooth suspension, and professional driving ensure devotees arrive relaxed and on time, ready for temple rituals and prayers. Group bus travel also simplifies logistics for elders and children, making the pilgrimage safe, comfortable, and well-organized from departure to return."
    },
    {
      "title": "Harihareshwar Beach Visit",
      "description": "Harihareshwar Beach offers a serene coastal experience with clean sands, gentle waves, and a calm atmosphere ideal for families and groups. Hiring a bus ensures everyone reaches the beach together without worrying about parking or route confusion. Passengers can enjoy the scenic Konkan drive, relax during travel, and carry picnic essentials comfortably. Group bus travel enhances safety and coordination, especially for large family outings, corporate picnics, or student trips, making the beach visit enjoyable and hassle-free."
    },
    {
      "title": "Konkan Coastal Scenic Route",
      "description": "The journey to Harihareshwar is known for its lush greenery, winding ghats, rivers, and coastal landscapes. Traveling by bus allows passengers to fully enjoy the scenic beauty without the fatigue of driving. Large windows, stable rides, and relaxed seating let travelers soak in nature, capture photographs, and enjoy conversations. For groups, this shared travel experience builds excitement and togetherness, turning the road journey into a memorable part of the trip."
    },
    {
      "title": "Family Leisure & Relaxation Trip",
      "description": "Harihareshwar is a preferred destination for peaceful family vacations away from city crowds. A rented bus ensures all family members travel together comfortably, regardless of age. Elders benefit from stable seating and smooth rides, while children enjoy the group atmosphere. The convenience of a single vehicle simplifies planning, reduces travel fatigue, and ensures everyone reaches the destination refreshed and ready to relax."
    },
    {
      "title": "Corporate Retreats & Team Outings",
      "description": "Corporate teams often choose Harihareshwar for retreats and bonding programs. Bus travel ensures punctual departures, disciplined schedules, and professional group management. Employees can interact during the journey, setting a positive tone for the retreat. Comfortable seating and reliable travel arrangements enhance overall satisfaction and reflect a professional approach to corporate travel planning."
    },
    {
      "title": "Group Picnic & Friends Trip",
      "description": "Friends planning group picnics or leisure trips to Harihareshwar prefer bus rentals for convenience and cost-effectiveness. Traveling together eliminates coordination issues, allows shared enjoyment, and ensures everyone arrives together. The bus journey becomes part of the fun, filled with music, conversations, and scenic views."
    },
    {
      "title": "Wedding & Family Functions Travel",
      "description": "Some families choose Harihareshwar for destination weddings or post-wedding leisure trips. Bus rentals provide organized transportation for guests, ensuring timely arrivals and comfortable travel. Managing large groups becomes easier, reducing stress during important family occasions."
    },
    {
      "title": "Student & Educational Trips",
      "description": "Educational institutions sometimes include coastal and temple destinations like Harihareshwar in their tours. Buses provide safe, supervised travel for students, allowing teachers to manage groups effectively while ensuring comfort and safety throughout the journey."
    },
    {
      "title": "Outstation Overnight Tours",
      "description": "Harihareshwar trips often involve overnight stays. Outstation buses provide sufficient space for luggage, smooth long-distance travel, and reliable performance on highways and ghats. Passengers can relax and enjoy the journey without concerns about vehicle reliability."
    },
    {
      "title": "Customized Travel Itineraries",
      "description": "Different groups have different travel preferences. Bus rentals allow customized routes, flexible pickup points, and adjustable schedules, ensuring the Harihareshwar trip aligns perfectly with group needs, whether it is a spiritual visit, leisure holiday, or corporate retreat."
    }
  ],

  "services": [
    {
      "name": "Bus on Rent for Harihareshwar",
      "description": "Sanavi Travels provides dedicated bus rental services for Harihareshwar trips, ensuring safe, comfortable, and reliable transportation for all group sizes. Our buses are suitable for long-distance coastal travel, offering spacious seating, smooth suspension, and professional drivers experienced with Konkan routes. Families, corporate groups, pilgrims, and tourists benefit from organized travel, transparent pricing, and flexible scheduling. With a focus on safety, punctuality, and comfort, our Harihareshwar bus rental service ensures a stress-free and enjoyable journey from start to finish."
    },
    {
      "name": "AC Bus for Harihareshwar",
      "description": "AC buses provide enhanced comfort for long journeys to Harihareshwar, especially during warm weather. Air-conditioned interiors keep passengers relaxed, reduce fatigue, and ensure a pleasant travel experience throughout the coastal drive."
    },
    {
      "name": "Non AC Bus Rental Harihareshwar",
      "description": "Non-AC buses offer a budget-friendly option for groups planning economical travel to Harihareshwar while maintaining safety, seating comfort, and reliable performance."
    },
    {
      "name": "Luxury Bus Hire Harihareshwar",
      "description": "Luxury buses are ideal for premium group travel, offering upgraded interiors, superior seating, and enhanced ride quality for a refined travel experience."
    },
    {
      "name": "Mini Bus on Rent Harihareshwar",
      "description": "Mini buses are suitable for smaller groups such as families or close-knit friends, offering easy maneuverability and comfortable travel for coastal routes."
    },
    {
      "name": "32 Seater Bus Harihareshwar",
      "description": "32 seater buses balance capacity and comfort, making them ideal for medium-sized groups traveling together to Harihareshwar."
    },
    {
      "name": "35 Seater Bus Hire Harihareshwar",
      "description": "35 seater buses accommodate larger groups efficiently, ensuring everyone travels together with sufficient space and comfort."
    },
    {
      "name": "Bus for Family Trip Harihareshwar",
      "description": "Family-focused bus services prioritize comfort, safety, and convenience, ensuring all age groups enjoy a smooth journey."
    },
    {
      "name": "Bus for Corporate Trip Harihareshwar",
      "description": "Corporate bus services ensure professional, punctual, and organized travel for team outings and retreats."
    },
    {
      "name": "Affordable Bus Rental Harihareshwar",
      "description": "Affordable pricing options allow groups to plan Harihareshwar trips within budget without compromising on travel quality."
    },
    {
      "name": "Best Bus Service Harihareshwar",
      "description": "Sanavi Travels is known for dependable service, customer satisfaction, and consistent quality for Harihareshwar routes."
    },
    {
      "name": "Bus with Driver Harihareshwar",
      "description": "All buses include experienced drivers familiar with Konkan highways and ghats, ensuring safe and smooth travel."
    },
    {
      "name": "Bus for Wedding Harihareshwar",
      "description": "Wedding-related group travel is managed efficiently with organized bus services, reducing logistical stress."
    },
    {
      "name": "Bus for Picnic Harihareshwar",
      "description": "Picnic bus services support relaxed group outings with coordinated travel and comfortable seating."
    },
    {
      "name": "Outstation Bus Harihareshwar",
      "description": "Outstation buses are equipped for long-distance journeys, providing reliability, comfort, and luggage space for overnight trips."
    }
  ],

  "tableData": [
    ["Harihareshwar Trip", "Outstation Bus"],
    ["AC Bus", "Non AC Bus"],
    ["Family Travel", "Corporate Travel"],
    ["32 Seater", "35 Seater"],
    ["Affordable", "Luxury Options"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Experienced Konkan Route Drivers",
      "WhyChoosedescription": "Our drivers are well-trained and highly experienced in handling Konkan coastal routes, ghats, and highways leading to Harihareshwar. Their route knowledge ensures safe navigation through winding roads, smooth driving on long stretches, and punctual arrivals. This expertise reduces travel stress for passengers, especially families, elders, and large groups, making the journey comfortable and secure throughout."
    },
    {
      "WhyChooseheading": "Comfort-Oriented Long Distance Travel",
      "WhyChoosedescription": "All buses are selected and maintained with long-distance comfort in mind. Spacious seating, proper legroom, and smooth suspension ensure passengers remain relaxed even during extended journeys. This focus on comfort helps travelers arrive refreshed and ready to enjoy Harihareshwar’s peaceful environment."
    },
    {
      "WhyChooseheading": "Group Travel Made Easy",
      "WhyChoosedescription": "Traveling as a group becomes simple and organized with a single bus. Coordinated pickups, unified travel schedules, and shared journeys eliminate confusion and delays, allowing everyone to stay together from departure to return."
    },
    {
      "WhyChooseheading": "Transparent & Affordable Pricing",
      "WhyChoosedescription": "Sanavi Travels follows clear pricing policies with no hidden charges. Groups can plan their Harihareshwar trip confidently, knowing the costs upfront and staying within budget."
    },
    {
      "WhyChooseheading": "Clean & Well-Maintained Buses",
      "WhyChoosedescription": "All buses are regularly cleaned, sanitized, and serviced to ensure hygiene, safety, and reliable performance. This commitment to maintenance enhances passenger confidence and overall travel quality."
    },
    {
      "WhyChooseheading": "Flexible Scheduling & Routes",
      "WhyChoosedescription": "Every group has unique travel needs. We offer flexible departure times, pickup points, and route customization to match your itinerary perfectly, ensuring a personalized travel experience."
    },
    {
      "WhyChooseheading": "Trusted Travel Partner",
      "WhyChoosedescription": "Sanavi Travels has built a strong reputation for dependable outstation travel services. Our consistent service quality and customer satisfaction make us a preferred choice for Harihareshwar trips."
    },
    {
      "WhyChooseheading": "End-to-End Travel Support",
      "WhyChoosedescription": "From booking assistance to journey completion, our support team ensures smooth coordination, quick responses, and reliable assistance whenever required during the trip."
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide buses for Harihareshwar from Pune?',
    answer: 'Yes, Sanavi Travels offers dedicated bus rental services from Pune and nearby areas to Harihareshwar. We provide AC, Non-AC, mini buses, and large seater buses suitable for families, corporate groups, pilgrims, and tourists. Our services are designed for safe, comfortable, and well-organized outstation travel with experienced drivers and reliable vehicles.'
  },
  {
    question: 'Is the service suitable for family and senior citizens?',
    answer: 'Absolutely. Our buses are comfortable, spacious, and driven by experienced drivers, making them ideal for families and senior citizens. Smooth rides, proper seating, and careful driving ensure a relaxed journey for all age groups traveling to Harihareshwar.'
  },
  {
    question: 'Are AC buses available for Harihareshwar trips?',
    answer: 'Yes, AC buses are available and recommended for long-distance travel to Harihareshwar. Air-conditioned interiors help reduce fatigue, especially during warm weather, ensuring passengers remain comfortable throughout the journey.'
  },
  {
    question: 'Can corporate groups book buses for Harihareshwar retreats?',
    answer: 'Yes, corporate groups frequently book our buses for team outings and retreats to Harihareshwar. We ensure punctual service, professional coordination, and comfortable group travel suitable for corporate schedules.'
  },
  {
    question: 'Do you provide drivers familiar with Konkan routes?',
    answer: 'Yes, all our drivers are experienced with Konkan coastal roads, ghats, and highways. Their familiarity ensures safe navigation, timely arrivals, and a smooth overall travel experience.'
  },
  {
    question: 'Is this service available for overnight trips?',
    answer: 'Yes, our outstation bus services are suitable for overnight and multi-day trips to Harihareshwar. Buses offer sufficient space for luggage and comfortable seating for extended journeys.'
  },
  {
    question: 'Can we customize pickup points and timings?',
    answer: 'Yes, we offer flexible pickup locations and departure times based on your group’s requirements. Customization helps ensure the trip aligns perfectly with your planned itinerary.'
  },
  {
    question: 'Is pricing transparent for Harihareshwar bus rentals?',
    answer: 'Yes, Sanavi Travels follows transparent pricing with no hidden charges. All costs are clearly communicated during booking, helping groups plan confidently.'
  },
  {
    question: 'Is the service suitable for wedding or picnic trips?',
    answer: 'Yes, our buses are commonly used for wedding-related travel, family picnics, and leisure outings to Harihareshwar. Organized group transport simplifies planning and enhances comfort.'
  },
  {
    question: 'How early should we book the bus?',
    answer: 'We recommend booking in advance, especially during weekends, holidays, and festival seasons, to ensure availability and preferred vehicle selection.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Kulkarni',
    feedback: 'We booked a bus from Sanavi Travels for our family trip to Harihareshwar, and the experience was truly excellent from start to finish. The bus was extremely clean, comfortable, and perfectly suited for a long coastal journey. The driver was very calm, experienced, and well-aware of Konkan routes, which made us feel safe throughout the trip. Traveling together as a family in one bus made the journey enjoyable, stress-free, and memorable. Everyone returned relaxed and happy, and we would definitely choose Sanavi Travels again.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Joshi',
    feedback: 'Our corporate team planned a weekend retreat to Harihareshwar and hired a bus from Sanavi Travels. The entire arrangement was highly professional, starting from booking support to on-time pickup and smooth travel. The bus was spacious, well-maintained, and very comfortable for long-distance travel. The driver maintained punctuality and drove safely through ghats and highways. Overall, the service exceeded our expectations and contributed greatly to the success of our team outing.',
    rating: 5
  }
];





























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent for Harihareshwar - Sanavi Travels",
  "description": "Sanavi Travels offers buses on rent for Harihareshwar trips, including AC, Non-AC, luxury, and mini bus options. Perfect for family trips, corporate travel, weddings, picnics, and outstation tours with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};




  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | Bus on Rent for Harihareshwar | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book buses for Harihareshwar trips with Sanavi Travels. AC, Non-AC, luxury, and mini bus options for family, corporate, wedding, picnic, and outstation travel with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/296.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentforharihareshwar;